import { gate } from 'hub-http/gates';
import { useIsUngated } from './useIsUngated';
export const useIsUngatedForBreezeRebrand = () => {
  return useIsUngated(gate('BreezeAssistant:Rebrand:2025'));
};